import React from 'react';

interface Props {
  handleDrop: (files: FileList) => void;
}

class DragArea extends React.Component<Props> {
  constructor(props: Props) {
    super(props);

    this.dropAreaRef = React.createRef();
  }

  state = {
    isDragging: false,
  };

  componentDidMount(): void {
    this.dragger = 0;
    const dropArea = this.dropAreaRef.current;
    if (dropArea) {
      dropArea.addEventListener('dragenter', this.handleDragIn);
      dropArea.addEventListener('dragleave', this.handleDragOut);
      dropArea.addEventListener('dragover', this.handleDrag);
      dropArea.addEventListener('drop', this.handleDrop);
    }
  }

  componentWillUnmount(): void {
    const dropArea = this.dropAreaRef.current;
    if (dropArea) {
      dropArea.removeEventListener('dragenter', this.handleDragIn);
      dropArea.removeEventListener('dragleave', this.handleDragOut);
      dropArea.removeEventListener('dragover', this.handleDrag);
      dropArea.removeEventListener('drop', this.handleDrop);
    }
  }

  dropAreaRef: React.RefObject<HTMLDivElement>;

  dragger!: number;

  handleDrag = (evt: DragEvent): void => {
    evt.preventDefault();
    evt.stopPropagation();
  };

  handleDragIn = (evt: DragEvent): void => {
    evt.preventDefault();
    evt.stopPropagation();

    this.dragger++;

    if (evt?.dataTransfer?.items && evt.dataTransfer.items.length > 0) {
      this.setState({ isDragging: true });
    }
  };

  handleDragOut = (evt: DragEvent): void => {
    evt.preventDefault();
    evt.stopPropagation();

    this.dragger--;

    if (this.dragger === 0) {
      this.setState({ isDragging: false });
    }
  };

  handleDrop = (evt: DragEvent): void => {
    evt.preventDefault();
    evt.stopPropagation();

    this.setState({ isDragging: false });
    if (evt?.dataTransfer?.files && evt.dataTransfer.files.length > 0) {
      this.props.handleDrop(evt.dataTransfer.files);
      evt.dataTransfer.clearData();
      this.dragger = 0;
    }
  };

  render(): React.ReactNode {
    const { isDragging } = this.state;

    return (
      <div className="w100 h100 pos-r" ref={this.dropAreaRef}>
        {isDragging && (
          <div
            className="w100 h100 pos-a"
            style={{
              backgroundColor: 'rgba(0, 116, 204, 0.1)',
            }}
          />
        )}
        {this.props.children}
      </div>
    );
  }
}

export default DragArea;
